import React from 'react';
import { Logos } from '../..';
import { PublicFooterCopyrightWrapper } from './PublicFooterCopyright.styles';
export const PublicFooterCopyright = () => {
  const BrandLogo = Logos.brandmarkDark;
  const currentYear = new Date().getFullYear();
  return /*#__PURE__*/React.createElement(PublicFooterCopyrightWrapper, null, /*#__PURE__*/React.createElement(BrandLogo, null), /*#__PURE__*/React.createElement("span", {
    "data-test-id": "copyright"
  }, "\xA9 Paddl Co. ".concat(currentYear)));
};